export default __webpack_public_path__ + "static/media/calendar.801c47ae.svg";